<div
  class="modal-backdrop"
  [class.is-open]="isOpen()"
  aria-hidden="true"
  (click)="onBackdropClick()"
></div>

<div
  #dialogPanel
  [class]="panelClasses()"
  role="dialog"
  aria-modal="true"
  [attr.aria-labelledby]="config.ariaLabelledby || null"
  [attr.aria-describedby]="config.ariaDescribedby || null"
  tabindex="-1"
>
  @if (config.title || config.showCloseButton) {
    <header class="modal-header">
      @if (config.title) {
        <h2 class="modal-title" id="modal-title">{{ config.title }}</h2>
      }

      @if (config.showCloseButton) {
        <button
          class="modal-close-btn"
          type="button"
          aria-label="Close dialog"
          (click)="requestClose('close-button')"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      }
    </header>
  }

  <div class="modal-body" id="modal-description">
    <ng-container #contentHost></ng-container>

    @if (!contentComponentType && config.description) {
      <p class="modal-generic-description">{{ config.description }}</p>
    }
  </div>
</div>
